import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { NodeViewWrapper, ReactNodeViewProps } from '@tiptap/react';
import katex from 'katex';
import 'katex/dist/katex.min.css';

/**
 * Standalone display equation (spec 046 FR-020, research Decision 5). Rendered by KaTeX in
 * display mode; the AI is prompted to emit LaTeX, so this node is how textbook-quality
 * notation lands on the page. `throwOnError: false` keeps malformed LaTeX visible as
 * source rather than crashing the canvas.
 */
const MathBlockNode: React.FC<ReactNodeViewProps> = ({ node }) => {
  const { latex } = node.attrs as { latex: string };
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      katex.render(latex || '', containerRef.current, {
        displayMode: true,
        throwOnError: false,
      });
    }
  }, [latex]);

  return (
    <NodeViewWrapper as="div">
      <Box ref={containerRef} sx={{ my: 1.5, textAlign: 'center', overflowX: 'auto' }} />
    </NodeViewWrapper>
  );
};

export default MathBlockNode;
